export const IS_AUTH: string = 'isAuth'